import { Link } from "react-router-dom";
import DashboardLayout from "@/pages/dashboard/components/DashboardLayout";
import { favoriteCleaners } from "@/mocks/dashboard";

export default function DashboardCleanersPage() {
  return (
    <DashboardLayout
      title="Favorite cleaners"
      subtitle="The pros you keep inviting back."
      action={
        <Link
          to="/booking"
          className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 pl-5 pr-2 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors cursor-pointer"
        >
          Find more cleaners
          <span className="w-7 h-7 flex items-center justify-center rounded-full bg-background-50">
            <i className="ri-search-line text-primary-600 text-sm"></i>
          </span>
        </Link>
      }
    >
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5">
        {favoriteCleaners.map((c) => (
          <article
            key={c.id}
            className="bg-background-50 border border-background-200 rounded-2xl overflow-hidden flex flex-col"
          >
            <div className="relative h-56 overflow-hidden">
              <img
                src={c.image}
                alt={c.name}
                className="w-full h-full object-cover object-top"
              />
              <button
                className="absolute top-3 right-3 w-9 h-9 flex items-center justify-center rounded-full bg-background-50/90 backdrop-blur text-accent-600"
                aria-label="Remove favorite"
              >
                <i className="ri-heart-3-fill text-base"></i>
              </button>
              <div className="absolute bottom-3 left-3 inline-flex items-center gap-1.5 bg-background-50/95 backdrop-blur px-2.5 py-1 rounded-full text-xs font-medium text-foreground-900">
                <i className="ri-star-fill text-secondary-500"></i> {c.rating}
              </div>
            </div>

            <div className="p-5 flex-1 flex flex-col">
              <div className="flex items-start justify-between gap-3">
                <div>
                  <h3 className="font-heading text-lg font-semibold text-foreground-950">
                    {c.name}
                  </h3>
                  <p className="text-xs text-foreground-600 mt-0.5">{c.role}</p>
                </div>
                <p className="text-right text-sm">
                  <span className="font-medium text-foreground-950">${c.rate}</span>
                  <span className="text-foreground-600">/hr</span>
                </p>
              </div>

              <p className="text-sm text-foreground-700 mt-3 leading-relaxed line-clamp-2">
                {c.bio}
              </p>

              <div className="flex flex-wrap gap-1.5 mt-4">
                {c.tags.map((t) => (
                  <span
                    key={t}
                    className="inline-flex items-center bg-background-100 text-foreground-700 px-2.5 py-1 rounded-full text-xs"
                  >
                    {t}
                  </span>
                ))}
              </div>

              <div className="grid grid-cols-2 gap-3 mt-5 pt-4 border-t border-background-200 text-xs">
                <div>
                  <p className="text-foreground-600">Visits with you</p>
                  <p className="font-medium text-foreground-950 mt-0.5">{c.bookings}</p>
                </div>
                <div>
                  <p className="text-foreground-600">Last booked</p>
                  <p className="font-medium text-foreground-950 mt-0.5">{c.lastBooked}</p>
                </div>
              </div>

              <div className="mt-4 bg-primary-50 border border-primary-200 rounded-xl px-3 py-2.5 flex items-center gap-2">
                <i className="ri-calendar-event-line text-primary-700"></i>
                <p className="text-xs text-primary-800">
                  Next available: <span className="font-medium">{c.nextAvailable}</span>
                </p>
              </div>

              <div className="flex items-center gap-2 mt-4">
                <Link
                  to="/booking"
                  className="flex-1 text-center bg-foreground-950 hover:bg-foreground-900 text-background-50 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap"
                >
                  Book again
                </Link>
                <button className="w-10 h-10 flex items-center justify-center rounded-full bg-background-100 hover:bg-background-200 text-foreground-700">
                  <i className="ri-message-3-line"></i>
                </button>
              </div>
            </div>
          </article>
        ))}

        {/* Add cleaner CTA */}
        <Link
          to="/booking"
          className="border-2 border-dashed border-background-300 rounded-2xl flex flex-col items-center justify-center min-h-[500px] p-8 text-center hover:border-primary-400 hover:bg-background-50 transition-colors group"
        >
          <span className="w-14 h-14 flex items-center justify-center rounded-full bg-background-100 group-hover:bg-primary-100 transition-colors">
            <i className="ri-add-line text-2xl text-foreground-700 group-hover:text-primary-700"></i>
          </span>
          <p className="mt-4 font-heading text-lg text-foreground-950">Find a new favorite</p>
          <p className="text-sm text-foreground-600 mt-1 max-w-[220px]">
            Browse all 320+ vetted cleaners and add the ones you click with.
          </p>
        </Link>
      </div>
    </DashboardLayout>
  );
}